
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/create-account",
      function () {
        return require("private-next-pages/signup/create-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/create-account"])
      });
    }
  